import { ADD_GLOBAL_WHATS_NEW, DELETE_GLOBAL_WHATS_NEW, GET_GLOBAL_WHATS_NEW, UPDATE_GLOBAL_WHATS_NEW } from "../types";
import {setAlert} from "./alert";
import axios from "../../axios";
import Swal from 'sweetalert2';
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getGlobalWhatsNew = () => async (dispatch) => {
    try {
        const res = await axios.get("whats-new/all");
        if (res.data.code === 1) {
            dispatch({type: GET_GLOBAL_WHATS_NEW, payload: res.data.data});
        }
    } catch (err) {
        console.log(err)
        // const errorMessage = err.response?.data?.message || 'An unexpected error occurred';
        const errorMessage = getErrorMessage(err.response?.data);

        Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
        });
    }
};


export const addGlobalWhatsNew = (formData, form) => async (dispatch) => {
    try {
        const res = await axios.post("whats-new/add", formData);
        console.log("formData add :", formData);
        
        if (res.data.code === 1) {
            dispatch({ type: ADD_GLOBAL_WHATS_NEW, payload: res.data.data });
            form.resetFields();
            Swal.fire({
                title: 'Success!',
                text: res.data.message,  // Only pass the message (string)
                icon: 'success',
            });
        } else {
            Swal.fire({
                title: 'Warning!',
                text: res.data.message,  // Only pass the message (string)
                icon: 'warning',
            });
        }
    } catch (err) {
          console.log(err)
        // Use the global error message function
        const errorMessage = getErrorMessage(err.response?.data);

        Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
        });
    }
};


export const updateGlobalWhatsNew = (formData, form) => async (dispatch) => {
    try {
        // const updatedFormData = { ...formData, id: formData._id };
        
        const updatedFormData = {
            id: formData.id,
            ...(formData.Date && { Date: formData.Date }),
            ...(formData.feature && { feature: formData.feature }),
            ...(formData.link && { link: formData.link }),
            // ...(formData.status !== undefined && { status: formData.status }),
            // ...(formData.status && { status: formData.status }),
        };
        console.log("updatedFormData :", updatedFormData);
        const res = await axios.post("whats-new/update", updatedFormData);
        
        if (res.data.code === 1) {
            dispatch({type: UPDATE_GLOBAL_WHATS_NEW, payload: res.data.data});
            console.log("suc :", res.data.message);
            
            Swal.fire({
                title: 'Success!',
                text: res.data.message,
                icon: 'success',
            });
            form.resetFields();
            return;
        }
        if (res.data.code === 2) {
            Swal.fire({
                title: 'Warning!',
                text: res.data.message,
                icon: 'warning',
            });
            return
        } 
    } catch (err) {
        // dispatch(setAlert(err.message, 'danger'));
         // Use the global error message function
         const errorMessage = getErrorMessage(err.response?.data);
        console.log("errorMessage :", err.response?.data);
        if (err.response?.data===undefined) {
            Swal.fire({
                title: 'Success!',
                text: "Updated Record!",
                icon: 'success',
            });
        }else{
            Swal.fire({
                title: 'Error!',
                text: errorMessage,
                icon: 'error',
            });
        }
    }
};

export const deleteGlobalWhatsNew = (_id) => async (dispatch) => {
    try {
        if (!_id) {
            dispatch(setAlert('Please select any record', 'warning'));
            return false;
        }
        const res = await axios.post(`whats-new/delete/${_id}`);
        if (res.data.code === 1) {
            dispatch({type: DELETE_GLOBAL_WHATS_NEW, payload: {_id}});
            dispatch(setAlert(res.data.message, 'success'));
            Swal.fire({
                title: 'Success!',
                text: res.data.message,
                icon: 'success',
            });
        } else {
            dispatch(setAlert(res.data.message, "warning"));
            Swal.fire({
                title: 'Warning!',
                text: res.data.message,
                icon: 'warning',
            });
        }
    } catch (err) {
        dispatch(setAlert(err.message, 'danger'));
        // Use the global error message function
        const errorMessage = getErrorMessage(err.response?.data);

        Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
        });
    }
};





